var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91791 7.96377L3.67089 11.1425C3.59248 11.2368 3.45241 11.2498 3.35804 11.1714C3.34754 11.1627 3.33783 11.153 3.32909 11.1425L0.0820768 7.96377C-0.0217466 7.86753 -0.0278961 7.70532 0.0683385 7.6015C0.116063 7.55001 0.182793 7.52034 0.25299 7.51942L1.79104 7.51943L1.79104 3.40083C1.82022 3.22871 1.95944 3.09646 2.13284 3.07611L4.86718 3.07611C5.00391 3.07611 5.03806 3.247 5.03806 3.40083L5.03806 7.51943L6.74703 7.51943C6.8886 7.52129 7.00184 7.63754 6.99998 7.77912C6.99906 7.84931 6.96939 7.91604 6.91791 7.96377Z",
    fill: "#EE6055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86765 2.56348L2.13331 2.56348C1.99173 2.56348 1.87695 2.44869 1.87695 2.30712C1.87695 2.16555 1.99173 2.05077 2.13331 2.05077L4.86765 2.05077C5.00922 2.05077 5.124 2.16555 5.124 2.30712C5.124 2.4487 5.00926 2.56348 4.86765 2.56348Z",
    fill: "#EE6055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86765 1.53809L2.13331 1.53809C1.99173 1.53809 1.87695 1.4233 1.87695 1.28173C1.87695 1.14016 1.99173 1.02538 2.13331 1.02538L4.86765 1.02538C5.00922 1.02538 5.124 1.14016 5.124 1.28173C5.124 1.4233 5.00926 1.53809 4.86765 1.53809Z",
    fill: "#EE6055"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86765 0.512696L2.13331 0.512695C1.99173 0.512695 1.87695 0.397914 1.87695 0.256342C1.87695 0.114771 1.99173 -1.01127e-05 2.13331 -1.0088e-05L4.86765 -9.60988e-06C5.00922 -9.58513e-06 5.124 0.114771 5.124 0.256343C5.124 0.397914 5.00926 0.512696 4.86765 0.512696Z",
    fill: "#EE6055"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSmallIcon);
export default __webpack_public_path__ + "static/media/ArrowDownSmallIcon.900dc739250141fe80df3edcc0a7b1e3.svg";
export { ForwardRef as ReactComponent };